<template>
    <div>
        <div class="space-md"></div>
        <b-card no-body class="overflow-hidden" v-for="item in data">
            <b-row no-gutters>
                <b-col md="4">
                    <b-card-img :src="'assets/images/' + item.url" class="image-card"></b-card-img>
                </b-col>
                <b-col md="8">
                    <b-card-body :title="item.titulo">
                        <b-card-text>
                            {{item.descricao}}
                        </b-card-text>
                        <b-card-text>
                            {{item.finalidade}}
                        </b-card-text>
                        <b-card-text>
                            {{item.embalagens}}
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

import {fb, db} from '../firebase'
import VueRecaptcha from 'vue-recaptcha'
import utilService from '../services/utilService'

export default {
  name: "ProductsList",
  props: ['data'],
  data () {
    return {}
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
